module.exports = __webpack_public_path__ + "img/EVOC.2377f061.png";